export default {
  SET_SEMIFINISHEDS(state, semifinisheds) {
    state.semifinisheds = semifinisheds;
  },
};
